<div class="tooltip trans50" [ngClass]="{'bottom':isBottom}" *ngIf="recipients?.length || groups?.length"
    (click)="stopClick($event)">
    <img class="triangular" src="/assets/images/grid/tooltip-triangular.svg">
    <div class="title">
        <ng-container *ngIf="title!=undefined; else defaultTitle">
            <p *ngIf="title=='recipients'" translate>data.tooltip.recipients</p>
            <p *ngIf="title=='groups'" translate>data.tooltip.users</p>
            <p *ngIf="title=='remindersUsers'" translate>data.tooltip.users</p>
            <p *ngIf="title=='dataUsers'" translate>data.tooltip.users</p>
        </ng-container>
    </div>
    <!-- <img class="triangular white" src="/assets/images/auto-fill/ttt.svg"> -->
    <div class="contact">
        <ng-container class="op-tool" *ngFor="let g of groups">
            <que-group-display-recipients [group]="g"></que-group-display-recipients>
            <!-- <que-mini-contact-display [user]="r.user" [isTooltip]="true" [color]="color"></que-mini-contact-display> -->
        </ng-container>
        <ng-container class="op-tool">
            <div  [ngClass]="{'recipients':groups?.length}">
                <que-mini-contact-display *ngFor="let r of recipients" [user]="r.user" [isTooltip]="true" [numGroups]="groups?.length "
                    [color]="color"></que-mini-contact-display>
            </div>
        </ng-container>
    </div>
    <img class="triangular-bottom" src="/assets/images/grid/tooltip-triangular.svg">
</div>
<ng-template #defaultTitle>
    <p translate>data.tooltip.distribution</p>
</ng-template>